// extracted by mini-css-extract-plugin
module.exports = {"message":"LoaderWithMessage_message__3kisl"};